var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header page-home"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v(" 申请使用通信服务涉实名登记及电信网络新型违法犯罪的防范提示及责任告知书 ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }